
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recent-funerals",
      function () {
        return require("private-next-pages/recent-funerals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recent-funerals"])
      });
    }
  